import React from 'react'
import { Popup } from 'antd-mobile-v5'

import styles from './AllCards.module.css'

const AllCardsList = ({ visible, setVisible, cardOptions }) => {
  const filteredCardOptions = cardOptions.filter((item) => item.id)

  return (
    <Popup
      className={styles.wrapper}
      visible={visible}
      onMaskClick={() => {
        setVisible(false)
      }}
      position="right"
      bodyStyle={{ width: '258px', overflowY: 'auto', paddingBottom: '12px' }}
    >
      <div className={styles.title}>所有卡片</div>
      {filteredCardOptions.map((option, index) => (
        <div className={styles['card-box']} key={option.id || index}>
          <div className={styles.card}>
            <img src={option.imageUrl} className={styles.img} alt="" />
          </div>
          <div className={styles['name-btn']}>{option.styleName}</div>
        </div>
      ))}
    </Popup>
  )
}

export default AllCardsList
